<p>add-product-multiple-dialog works!</p>
